<template>
  <!-- <dv-border-box-4
    :color="['#266c6d', '#101d40']"
    :reverse="true"
  > -->
  <div class="rightCharts-container">
    <div class="top-content">
      <h3 class="global-titleShadow">能耗</h3>
      <div class="border-content">
        <div class="top-card">
          <h4>
            <div class="global-dot"></div>近30日总能耗(度)
          </h4>
          <LineCharts
            :xAxisData="day30Arr"
            :yAxisData="energy30Arr"
          ></LineCharts>
        </div>
        <div class="top-card">
          <h4>
            <div class="global-dot"></div>产线累计能耗(度)
          </h4>
          <BarCharts
            :xAxisData="lineNameArr"
            :yAxisData="consumptionArr"
            :yUnitType="'w'"
          ></BarCharts>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <h3 class="global-titleShadow">问题</h3>
      <div class="border-content">
        <h4>
          <div class="global-dot"></div>问题分布
        </h4>
        <TreemapCharts :seriesData="projectIssuesArr"></TreemapCharts>
      </div>
    </div>
  </div>
  <!-- </dv-border-box-4> -->
</template>

<script>
import axios from 'axios';
import BarCharts from './LeftCharts/BarCharts.vue';
import LineCharts from './LeftCharts/LineCharts.vue';
import TreemapCharts from './RightCharts/TreemapCharts.vue';
import * as moment from 'moment';

export default {
  name: 'RightCharts',
  components: {
    BarCharts,
    LineCharts,
    TreemapCharts
  },
  data () {
    return {
      day30Arr: [],
      day30Ago: moment().add(-29, 'd').format("YYYY-MM-DD"),
      dayToday: moment().add(1, 'd').format("YYYY-MM-DD"),
      energy30Arr: [],
      lineNameArr: ['A2', 'D1', 'D2', 'Y1', 'E1', 'JDD3', 'S', 'X'],
      consumptionArr: [],
      projectIssuesArr: [],
      timer: '',
    }
  },
  mounted () {
    for (let i = 1; i < 31; i++) {
      this.day30Arr.push(i)
    }
    this.handleEnergy30Req()
    this.handleConsumptionReq()
    this.handleProjectIssuesReq()
    this.timer = setInterval(() => {
      this.handleEnergy30Req()
      this.handleConsumptionReq()
      this.handleProjectIssuesReq()
    }, 1000 * 60 * 5)
  },
  methods: {
    handleAdd (arr, threshold) {
      let result = 0;
      for (let ele of arr) {
        if (!threshold || Number(ele) <= threshold) {
          result += Math.ceil(Number(ele))
        }
      }
      return result
    },
    // handleEnergy30Req () {
    //   let total = []
    //   let energy30ReqArr = [
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.a2.zs-tek.com/Equipment/Equipment/GetEquipmentEnergyData',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.d1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.d2.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     // this.$axios({
    //     //   method: 'get',
    //     //   url: 'https://api.y1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
    //     //   params: {
    //     //     beginTime: this.day30Ago,
    //     //     endTime: this.dayToday,
    //     //     timeRangeType: 2
    //     //   }
    //     // }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.e1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.jdd3.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.s1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRangeByLineCode',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.x.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRangeByLineCode',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //   ]
    //   this.$axios.all(energy30ReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     for (let i = 0; i < 30; i++) {
    //       total.push(this.handleAdd([
    //         a2.data.chartModels[i].value,
    //         d1.data[i].count,
    //         d2.data[i]?.count ?? 0,
    //         0,
    //         e1.data[i]?.count ?? 0,
    //         jdd3.data[i].count,
    //         s1.data[0].values[i].count,
    //         s1.data[1].values[i].count,
    //         s1.data[2].values[i].count,
    //         s1.data[3].values[i].count,
    //         x.data[0].values[i].count,
    //         x.data[1].values[i].count,
    //         x.data[2].values[i].count,
    //         x.data[3].values[i].count,
    //       ], 1000))
    //     }
    //     // console.log(total)
    //     this.energy30Arr = total
    //   })).catch((err) => {
    //     this.$message.error('30日总能耗通讯异常')
    //   })
    // },
    handleEnergy30Req () {
      let total = []
      let energy30ReqArrTem = []
      let energy30ReqArr = [
        {
          method: 'get',
          url: 'https://api.a2.zs-tek.com/Equipment/Equipment/GetEquipmentEnergyData',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.d1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.d2.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.y1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.e1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.jdd3.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.s1.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRangeByLineCode',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.x.zs-tek.com/Equipment/GetElectricityQuantityInKWHByTimeRangeByLineCode',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
      ]
      // this.$axios.all(energy30ReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
      //   for (let i = 0; i < 30; i++) {
      //     total.push(this.handleAdd([
      //       a2.data.chartModels[i].value,
      //       d1.data[i].count,
      //       d2.data[i]?.count ?? 0,
      //       0,
      //       e1.data[i]?.count ?? 0,
      //       jdd3.data[i].count,
      //       s1.data[0].values[i].count,
      //       s1.data[1].values[i].count,
      //       s1.data[2].values[i].count,
      //       s1.data[3].values[i].count,
      //       x.data[0].values[i].count,
      //       x.data[1].values[i].count,
      //       x.data[2].values[i].count,
      //       x.data[3].values[i].count,
      //     ], 1000))
      //   }
      //   // console.log(total)
      //   this.energy30Arr = total
      // })).catch((err) => {
      //   this.$message.error('30日总能耗通讯异常')
      // })
      Promise.allSettled(energy30ReqArr.map(({ method, url, params }) =>
      // fetch(`${url}?${new URLSearchParams(params).toString()}`, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url: `${url}?${new URLSearchParams(params).toString()}`, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (Array.isArray(result.value)) {
                energy30ReqArrTem[index] = result.value;
              } else {
                energy30ReqArrTem[index] = []
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          for (let i = 0; i < 30; i++) {
            total.push(this.handleAdd([
              energy30ReqArrTem[0]?.chartModels?.[i]?.value ?? 0,
              energy30ReqArrTem[1][i]?.count ?? 0,
              energy30ReqArrTem[2][i]?.count ?? 0,
              0,
              energy30ReqArrTem[4][i]?.count ?? 0,
              energy30ReqArrTem[5][i]?.count ?? 0,
              energy30ReqArrTem[6][0]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[6][1]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[6][2]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[6][3]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[7][0]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[7][1]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[7][2]?.values?.[i]?.count ?? 0,
              energy30ReqArrTem[7][3]?.values?.[i]?.count ?? 0,
            ], 1000))
          }
          this.energy30Arr = total;
        });
    },
    // handleConsumptionReq () {
    //   let consumptionReqArr = [
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.a2.zs-tek.com/Equipment/Equipment/GetEquipmentEnergyData',
    //       params: {
    //         beginTime: '2019-01-01',
    //         endTime: this.dayToday,
    //         timeRangeType: 6
    //       }
    //     }),
    //     this.$axios({ method: 'get', url: 'https://api.d1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     this.$axios({ method: 'get', url: 'https://api.d2.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     // this.$axios({ method: 'get', url: 'https://api.y1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     this.$axios({ method: 'get', url: 'https://api.e1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     this.$axios({ method: 'get', url: 'https://api.jdd3.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     this.$axios({ method: 'get', url: 'https://api.s1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //     this.$axios({ method: 'get', url: 'https://api.x.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' }),
    //   ]
    //   this.$axios.all(consumptionReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     this.consumptionArr = [a2.data.totalEnergy, d1.data, 121074, 0, 10000, 71074, s1.data, x.data];
    //   })).catch((err) => {
    //     this.$message.error('累计能耗通讯异常')
    //   })
    // },
    handleConsumptionReq () {
      let consumptionReqArrTem = [];
      let consumptionReqArr = [
        {
          method: 'get',
          url: 'https://api.a2.zs-tek.com/Equipment/Equipment/GetEquipmentEnergyData',
          params: {
            beginTime: '2019-01-01',
            endTime: this.dayToday,
            timeRangeType: 6
          }
        },
        { method: 'get', url: 'https://api.d1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.d2.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.y1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.e1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.jdd3.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.s1.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
        { method: 'get', url: 'https://api.x.zs-tek.com/Equipment/GetTotalElectricityQuantityInKWH' },
      ]
      // this.$axios.all(consumptionReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
      //   this.consumptionArr = [a2.data.totalEnergy, d1.data, 121074, 0, 10000, 71074, s1.data, x.data];
      // })).catch((err) => {
      //   this.$message.error('累计能耗通讯异常')
      // })
      Promise.allSettled(consumptionReqArr.map(({ method, url, params }) =>
      // fetch(`${url}?${new URLSearchParams(params).toString()}`, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url: `${url}?${new URLSearchParams(params).toString()}`, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (!isNaN(Number(result.value))) {
                consumptionReqArrTem[index] = Number(result.value);
              } else if (!isNaN(Number(result.value?.totalEnergy))) {
                consumptionReqArrTem[index] = Number(result.value?.totalEnergy);
              } else {
                consumptionReqArrTem[index] = 0
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          consumptionReqArrTem[2] = 121074;
          consumptionReqArrTem[3] = 0;
          consumptionReqArrTem[4] = 10000;
          consumptionReqArrTem[5] = 71074;
          this.consumptionArr = consumptionReqArrTem;
        });
    },
    // handleProjectIssuesReq () {
    //   let projectIssuesReqArr = [
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.miszs.zs-tek.com/GetProjectIssues',
    //       params: {
    //         dayRecentCount: 30
    //       }
    //     }),
    //   ]
    //   this.$axios.all(projectIssuesReqArr).then(this.$axios.spread((res) => {
    //     let objTem = {}
    //     let result = []
    //     for (let ele of res.data) {
    //       if (objTem[ele.l] === undefined) {
    //         objTem[ele.SecondaryClassificationName] = 1
    //       } else {
    //         objTem[ele.SecondaryClassificationName]++
    //       }
    //     }
    //     for (let key in objTem) {
    //       result.push({
    //         name: key,
    //         value: objTem[key]
    //       })
    //     }
    //     if (result.length === 0) {
    //       result = [{ name: '暂无问题', value: 6 }]
    //     }
    //     console.log(result)
    //     this.projectIssuesArr = result
    //   })).catch((err) => {
    //     this.$message.error('问题分布通讯异常')
    //   })
    // }
    handleProjectIssuesReq () {
      let projectIssuesReqArr = [
        this.$axios({
          method: 'get',
          url: 'https://api2.miszs.zs-tek.com/ProjectIssues/GlueSprayWorkStationCount',
          params: {
            from: moment().subtract(1, 'months').format('YYYY-MM-DD'), // 1月前,
            from: moment().format('YYYY-MM-DD')
          }
        }),
      ]
      this.$axios.all(projectIssuesReqArr).then(this.$axios.spread((res) => {
        let result = []
        for (const ele of res.data?.content) {
          result.push({
            name: ele.problemTypeName,
            value: ele.count
          })
        }
        if (result.length === 0) {
          result = [{ name: '暂无问题', value: 6 }]
        }
        this.projectIssuesArr = result

      })).catch((err) => {
        this.$message.error('问题分布通讯异常')
      })
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style scoped>
.rightCharts-container {
  color: #fff;
  text-align: left;
  padding: 15px 15px;
  box-sizing: border-box;
  height: 100%;
}

.top-content {
  height: 65%;
  /* background-color: antiquewhite; */
}

.top-card {
  margin-top: 5px;
}

.bottom-content {
  height: 35%;
  /* background-color: brown; */
}

h3 {
  font-size: 25px;
  line-height: 35px;
  padding-left: 20px;
  color: #0efcff;
  letter-spacing: 1px;
}

h4 {
  font-size: 22px;
  display: flex;
  align-items: center;
  text-indent: 4px;
  line-height: 44px;
}

.border-content {
  padding: 0px 16px 0 16px;
}
</style>
